module.exports = __webpack_public_path__ + "img/logo2.826bf256.jpg";